import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import TermsAndConditions from '../terms-and-conditions-link';
import PBGUserAgreement from '../pbg-user-agreement';
import Title from '../title';

class DashboardTermsAndConditions extends Component {
  renderMerchantTermsConditions() {
    if (!this.props.legalDocuments.length) return null;

    return (
      <p>
        {this.props.merchantName}:
        {' '}
        <TermsAndConditions
          text={
            <FormattedMessage
              id="termsAndConditions.termsOfService"
              defaultMessage="Terms of Service"
            />
          }
          slug={this.props.slug}
          legalDocuments={this.props.legalDocuments}
        />
      </p>
    );
  }

  renderPayByGroupConditions() {
    return (
      <p>
        <FormattedMessage
           id="termsAndConditions.payByGroup"
           defaultMessage="Key Travel:"
        />
        {' '}
        <PBGUserAgreement
          text={
            <FormattedMessage
              id="termsAndConditions.userAgreement"
              defaultMessage="User Agreement"
            />
          }
        />
      </p>
    );
  }

  render() {
    return (
      <div className="dashboard-terms-and-conditions">
        <Title
          text={
            <FormattedMessage
              id="termsAndConditions.title"
              defaultMessage="Terms & Conditions"
            />
          }
          bigger
          className="pb-4"
          name="terms"
        />
        {this.renderMerchantTermsConditions()}
        {this.renderPayByGroupConditions()}
      </div>
    );
  }
}

DashboardTermsAndConditions.defaultProps = {
  merchantName: 'Merchant',
  slug: null,
  legalDocuments: [],
};

export default DashboardTermsAndConditions;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/terms-and-conditions.js